import { FC, useState, useEffect, useRef } from 'react'

import './style.scss'

type SliderProps = {
  className?: string
  style?: any,
  slides: Array<any>,
  autoplay?: number
}

const currentDefault: number = 0

const Slider:FC<SliderProps> = ({ children, className = '', style, slides, autoplay = 5000 }) => {
  const [current, setCurrent] = useState<number>(currentDefault)
  const autoplayRef = useRef<any>()
  const slidesLength = slides.length

  useEffect(() => {
    autoplayRef.current = nextSlide
  })

  useEffect(() => {
    const play = () => autoplayRef.current()

    if(autoplay > 0) {
      const interval = setInterval(play, autoplay)
      return () => clearInterval(interval)
    }
  }, [autoplay])

  const nextSlide = () => {
    const index = (current < (slidesLength - 1) ? current + 1 : currentDefault)
    setCurrent(index)
  }

  const onDotsClick = (index: number) => {
    setCurrent(index)
  }

  if(slidesLength <= currentDefault) return null

  return (
    <>
      <div className={`sliders ${className}`} style={style}>
        {slides && slides.length && slides.map((slide, i) =>
          <div key={i} className={`sliders_item ${i === current ? 'sliders_item--active' : ''}`}>
            {i === current &&
              <a href={slide.url} target="_blank"rel="noreferrer">
                <img src={slide.image} alt="" width="" height="" className="img-resp" />
              </a>
            }
          </div>
        )}
      </div>

      <div className="sliders-dots mt-10">
        {slides && slides.length && slides && slides.map((slide, i) =>
          <div key={i} className="sliders-dots_item">
            <span className={`sliders-dots_cirle ${i === current ? 'sliders-dots_item--active' : ''}`} onClick={() => onDotsClick(i)}>{i + 1}</span>
          </div>
        )}
      </div>
    </>
  )
}

export { Slider }